require('lightgallery.js/dist/js/lightgallery.js');

export default class ImageGallery {
  init() {
    const elements = document.querySelectorAll('.ImageGallery--slideshow');
    const controlElement = "<svg class=\"SvgIcon\" aria-hidden=\"true\" role=\"presentation\" shape-rendering=\"geometricPrecision\" style=\"--svg-size: 48px\"><use class=\"icon-chevron-left-icon\" xlink:href=\"/images/icons.svg#icon-chevron-left-icon\"></use></svg>";

    elements.forEach(gallery => {
       lightGallery(gallery, {
         selector: '.ImageGalleryItem__image',
         counter: false,
         download: false,
         prevHtml: controlElement,
         nextHtml: controlElement
       })
    })
  }
}
